import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';

import { TabItem } from './tab-item.component';

@Component({
  selector: 'suka-tabs',
  template: `
    <div class="tabs-wrapper">
      <ul class="tabs">
        <li
          *ngFor="let tab of tabs"
          (click)="selectTab(tab)"
          [class.tabs__tab-container--selected]="tab.active"
          class="tabs__tab-container"
        >
          <button class="tabs__tab" type="button" role="tab">
            <span class="tabs__title">
            <ng-container *ngIf="!isTemplate(tab.title)">{{tab.title}}</ng-container>
            <ng-template *ngIf="isTemplate(tab.title)" [ngTemplateOutlet]="tab.title"></ng-template>
            </span>
          </button>
        </li>
      </ul>
    </div>
    <ng-content></ng-content>
  `,
})
export class Tabs implements AfterContentInit {
  /**
   * Set to `true` to fit tabs to container.
   */
  @HostBinding('class.tabs-fitted') @Input() fitted = false;

  /**
   * List of tabs associated to the main wrapper.
   */
  @ContentChildren(TabItem) tabs: QueryList<TabItem>;

  ngAfterContentInit() {
    const activeTabs = this.tabs.filter((tab) => tab.active);

    if (activeTabs.length === 0 && this.tabs.length > 0) {
      this.selectTab(this.tabs.first);
    }
  }

  /**
   * Selects a particular tab and activates it.
   */
  selectTab(tabItem: TabItem) {
    this.tabs.toArray().forEach(tab => tab.active = false);

    tabItem.activate();
  }

  public isTemplate(value) {
    return value instanceof TemplateRef;
  }
}
